import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY, catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../../oglasnik-v3/shared/services/auth.service';

const AUTH_PATHS_NO_REFRESH = [
  '/auth/authenticate',
  '/auth/registracija',
  '/auth/potvrda-emaila',
  '/auth/refresh-token',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/logout',
];

/**
 * Hvata 401 na zaštićenim requestima i pokušava refresh prije nego
 * baci error gore. MORA biti registriran PRIJE authInterceptor-a:
 * `withInterceptors([refreshTokenInterceptor, authInterceptor])`.
 * Tako retry prolazi kroz authInterceptor i pokupi novi Bearer iz signala.
 */
export const refreshTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401) return throwError(() => error);
      if (AUTH_PATHS_NO_REFRESH.some(p => req.url.includes(p))) {
        return throwError(() => error);
      }

      return auth.refreshAccessToken().pipe(
        switchMap(() => next(req)),
        catchError(() => {
          auth.logout();
          return EMPTY;
        }),
      );
    }),
  );
};
